import { create } from "zustand";
import LoadingSpinner from "./loading-spinner";
import { Logo } from "./sidebar/Logo";

type OrganizationSwitchStore = {
    organizationName: string | null;
    start: (organizationName: string) => void;
    stop: () => void;
};

// Global so the overlay survives the dropdown (and its trigger) unmounting on click.
const useOrganizationSwitchStore = create<OrganizationSwitchStore>((set) => ({
    organizationName: null,
    start: (organizationName: string) => set({ organizationName }),
    stop: () => set({ organizationName: null }),
}));

export { useOrganizationSwitchStore };

// Covers the whole app while the active organization is being switched, so the
// data of the previous organization is never visible in the new organization's
// context (queries are invalidated and the app reloads underneath this overlay).
export function OrganizationSwitchOverlay() {
    const organizationName = useOrganizationSwitchStore((state) => state.organizationName);

    if (!organizationName) return null;

    return (
        <div className="fixed inset-0 z-1001 flex items-center justify-center bg-orsane-background">
            <div className="flex flex-col items-center gap-4">
                <Logo className="w-[72px]! block" />
                <div className="flex items-center gap-2 text-orsane-secondary">
                    <LoadingSpinner size="sm" />
                    <span className="text-sm font-medium">Switching organization...</span>
                </div>
                <div className="text-sm text-orsane-muted">{organizationName}</div>
            </div>
        </div>
    );
}
